import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ModifyFormConfigComponent} from './components/modify-form-config/modify-form-config.component';
import {FormPerformanceComponent} from './components/form-performance/form-performance.component';
import {FormInteractionComponent} from './components/form-interaction/form-interaction.component';
import {FillFormComponent} from './components/fill-form/fill-form.component';
import {LayoutsComponent} from './components/layouts/layouts/layouts.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'form-config',
        pathMatch: 'full'
    },
    {
        path: 'fill-form',
        component: FillFormComponent
    },
    {
        path: 'form-config',
        component: ModifyFormConfigComponent
    },
    {
        path: 'form-performance',
        component: FormPerformanceComponent
    },
    {
        path: 'form-interaction',
        component: FormInteractionComponent
    },
    {
        path: 'form-layouts',
        component: LayoutsComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
